<script lang="ts">
	import type { AntonioStepOption } from '#src/types/antonio-step.ts';

	interface Props {
		/** The picked options, in the step's order. */
		options: AntonioStepOption[];
	}

	const { options }: Props = $props();
</script>

<!-- Not a bubble: the visitor picked this, they didn't write it, and the LLM
     reads it as a marked pick too (see ragChoiceContent in backend/routes/antonio_steps.go). -->
<div class="antonio-pick">
	<ul>
		{#each options as option (option.id)}
			<li class:with-image={option.imageUrl}>
				{#if option.imageUrl}
					<img src={option.imageUrl} alt="" />
				{/if}
				<span>{option.label}</span>
			</li>
		{/each}
	</ul>
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.antonio-pick {
		@include lib.flex-column();
		@include lib.flex-align(flex-start, flex-end);

		ul {
			@include lib.flex-row();
			@include lib.flex-align(flex-end, center);
			flex-wrap: wrap;
			gap: 0.5rem;
			margin: 0;
			padding: 0;
			list-style: none;

			// The selected option card from AntonioChoiceInput, shrunk and in neutral colors.
			li {
				@include lib.flex-row();
				@include lib.flex-align(flex-start, center);
				gap: 0.5rem;
				padding: 0.25rem 0.75rem;
				border: 2px solid var(--border-strong);
				// Image radius plus padding and border, so the corners stay concentric.
				border-radius: 0.875rem;
				background: var(--surface-2);

				&.with-image {
					padding-left: 0.25rem;
				}

				img {
					width: 2rem;
					height: 2rem;
					object-fit: cover;
					border-radius: 0.5rem;

					@include lib.bp(gt-sm) {
						width: 3rem;
						height: 3rem;
					}
				}
			}
		}
	}
</style>
